import React, { Fragment } from "react";
import { Table } from "reactstrap";
import style from "./HistoryTable.scss";
import { FormattedNumber } from "../FormattedNumber/FormattedNumber";

const HistoryTable = ({ activity, currencyFilter, getActivityPDF, toPascalCase, pdf }) => {
  return (
    <div className={style.tableWrapper}>
      <Table responsive>
        <thead>
          <tr>
            <th>Fecha</th>
            <th>Tipo</th>
            <th>Descripción</th>
            <th>Monto operado</th>
            <th>Moneda</th>
          </tr>
        </thead>
        <tbody>
          <Fragment>
            {activity &&
              // we use .slice(0).reverse(). to display the most recent files first in the table.
              activity
                .slice(0)
                .reverse()
                .map((activityItem) => {
                  let minDecimal = 0;
                  let maxDecimal = 8;
                  if (currencyFilter.esEfectivo) {
                    if (currencyFilter.ISO === "USD") {
                      minDecimal = 2;
                      maxDecimal = 2;
                    } else {
                      minDecimal = 0;
                      maxDecimal = 0;
                    }
                  }

                  return (
                    <tr>
                      <td>{activityItem.fecha}</td>
                      <td>{toPascalCase(activityItem.concepto)}</td>
                      <td>{activityItem.nombre === "" ? "-" : activityItem.nombre}</td>
                      <td>
                        <FormattedNumber
                          value={activityItem.saldo_total}
                          minimumFractionDigits={minDecimal}
                          maximumFractionDigits={maxDecimal}
                        />
                      </td>
                      <td>{activityItem.currencyISO}</td>
                      <td>
                        {!currencyFilter.esEfectivo &&
                          !["Saldo Inicial", "Saldo Final"].includes(activityItem.concepto) && (
                            <img
                              src={pdf}
                              alt="PDF"
                              style={{ cursor: "pointer" }}
                              onClick={() => getActivityPDF(activityItem)}
                            />
                          )}
                      </td>
                    </tr>
                  );
                })}
          </Fragment>
        </tbody>
      </Table>
    </div>
  );
};
export default HistoryTable;
